module.exports = __webpack_public_path__ + "static/media/eng_d_2294.91f9832a.vtt";